<template>
  <v-toolbar fixed light>
    <v-toolbar-side-icon light @click.native.stop="toggle()"></v-toolbar-side-icon>
    <v-toolbar-title>Manager</v-toolbar-title>
    <CreditValue v-if="$can('admin', 'platform')" />
    <v-btn
      icon light
      class="btn-toolbar-notification"
      router :href="{ name: 'Messenger' }">
      <v-icon
        v-if="pendingMessagesLength"
        class="red--after"
        v-badge="{ value: pendingMessagesLength }">
        notifications
      </v-icon>
    </v-btn>
    <v-toolbar-items>
      <v-btn
        v-if="inPause || pauseLoading"
        error light
        :loading="pauseLoading"
        @click.native.stop="finishPause()">
        {{ $t('applicationtoolbar.finishPause') }}
      </v-btn>
      <v-menu bottom left v-if="waitingForAcceptancePurchases.length > 0">
        <v-btn light icon class="btn-toolbar-notification" slot="activator">
          <v-icon
            class="red--after"
            v-badge="{ value: waitingForAcceptancePurchases.length }">
            assignment_turned_in
          </v-icon>
        </v-btn>
        <v-list>
          <v-list-tile v-for="purchase in waitingForAcceptancePurchases" :key="purchase.id" nuxt :to="`/purchases/${purchase.id}`">
            <v-list-tile-content>
              <v-list-tile-title>
                {{ purchase.offer.title }}
              </v-list-tile-title>
              <v-list-tile-sub-title>
                {{ purchase.user.nickname }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-menu bottom left>
        <v-btn light icon slot="activator">
          <v-icon>notification_important</v-icon>
        </v-btn>
        <Activities small></Activities>
      </v-menu>
      <v-menu bottom left>
        <v-btn light icon slot="activator">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-item v-if="!inPause">
            <v-list-tile @click.native="pause()">
              <v-list-tile-title>{{ $t('applicationtoolbar.pause') }}</v-list-tile-title>
            </v-list-tile>
          </v-list-item>
          <v-list-item>
            <v-list-tile router :href="{ name: 'Account', params: { tab: 'profile' } }">
              <v-list-tile-title>{{ $t('applicationtoolbar.edit') }}</v-list-tile-title>
            </v-list-tile>
          </v-list-item>
          <v-list-item>
            <v-list-tile router :href="{ name: 'Logout' }">
              <v-list-tile-title>{{ $t('applicationtoolbar.logout') }}</v-list-tile-title>
            </v-list-tile>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
    <AvailabilityPopup v-if="availabilityPurchases.length > 0" :purchases="availabilityPurchases" />
  </v-toolbar>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'
  import debounce from 'lodash.debounce'
  import Activities from '@/components/Activities'
  import AvailabilityPopup from '@/components/purchase/popup/Availability'
  import CreditValue from '@/components/extensions/credit/value'
  export default {
    components: {
      Activities,
      AvailabilityPopup,
      CreditValue
    },
    computed: {
      ...mapGetters({
        currentUser: 'skiliko/session/currentUser',
        pending: 'skiliko/messages/pending',
        pendingConversations: 'skiliko/conversations/pending',
        pauseLoading: 'skiliko/pauses/isLoading',
        platform: 'skiliko/session/currentPlatform',
        purchases: 'skiliko/purchases/collection'
      }),
      pendingMessagesLength () {
        return Object.keys(this.pending).length
      },
      pendingConversationsLength () {
        return Object.keys(this.pendingConversations).length
      },
      inPause () {
        return this.currentUser.current_pause
      },
      currentUserPurchases () {
        return Object.keys(this.purchases)
          .map((id) => this.purchases[id])
          .filter((purchase) => purchase.admin_id === this.currentUser.id)
      },
      waitingForAcceptancePurchases () {
        return this.currentUserPurchases
          .filter((purchase) => !purchase.accepted_at && purchase.payed_at && !purchase.refunded_at)
      },
      availabilityPurchases () {
        return this.waitingForAcceptancePurchases
          .filter((purchase) => purchase.offer.service_type === 'availability')
          .filter((purchase) => purchase.offer.service_options.availability_type === 'chat')
      }
    },
    methods: {
      ...mapMutations({
        toggle: 'application/TOGGLE_MENU'
      }),
      ...mapActions({
        pause: 'skiliko/pauses/create',
        finishPause: 'skiliko/pauses/cancel'
      })
    },
    watch: {
      pendingMessagesLength: debounce((current, previous) => {
        if (window && window.document && window.document.title) {
          const defaultTitle = (window.document.title.match(/^\(\d\) (.*)$/) || [null, window.document.title])[1]
          window.document.title = current
            ? `(${current}) ${defaultTitle}`
            : defaultTitle
        }
      }, 100)
    }
  }
</script>

<style>
  .btn-toolbar-notification .btn__content {
    overflow: visible;
  }

  .btn-toolbar-notification .icon::after {
    top: -10px;
    right: -10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ApplicationToolbar.vue